import { createPortal } from 'react-dom';
import { useToastStore } from '../../store/toastStore';

const icons = {
  success: (
    <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
    </svg>
  ),
  error: (
    <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  info: (
    <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
    </svg>
  ),
};

const styles = {
  success: 'bg-olivine/15 border-olivine-dark/40',
  error: 'bg-danger/10 border-danger/40',
  info: 'bg-champagne-light border-chocolate-dark/40',
};

const iconStyles = {
  success: 'text-olivine-dark',
  error: 'text-danger',
  info: 'text-chocolate-dark',
};

export function Toaster() {
  const { toasts, dismiss } = useToastStore();

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="fixed top-[calc(env(safe-area-inset-top)+0.75rem)] md:top-auto md:bottom-5 right-4 md:right-5 left-4 md:left-auto z-toast flex flex-col gap-2 md:w-full md:max-w-sm pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.type === 'error' ? 'alert' : 'status'}
          className={`flex items-center gap-3 pl-4 pr-1 py-1 min-h-[3rem] rounded-xl border shadow-lg pointer-events-auto animate-slide-in ${styles[t.type]}`}
        >
          <span className={iconStyles[t.type]}>{icons[t.type]}</span>
          <p className="text-sm font-medium text-text-dark flex-1 py-2">{t.message}</p>
          {t.action && (
            <button
              type="button"
              onClick={() => {
                t.action?.onClick();
                dismiss(t.id);
              }}
              className="text-sm font-bold text-chocolate-dark hover:text-chocolate-deep underline shrink-0 rounded min-h-[2.75rem] px-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-2"
            >
              {t.action.label}
            </button>
          )}
          <button
            type="button"
            aria-label="Fechar aviso"
            onClick={() => dismiss(t.id)}
            className="w-11 h-11 flex items-center justify-center text-text-medium hover:text-text-dark transition-colors shrink-0 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-2"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ))}
    </div>,
    document.body
  );
}
